import { REWARD_API } from "../../../utils/constants/apis.urls";
import { axiosInstance } from "../../../config/interceptor";
import Cookies from "js-cookie";

export const getTremendousOAuth = (code: string) => {
  const user_id = parseInt(Cookies.get('user_id') || '0', 10);
  return axiosInstance.post(REWARD_API.GET_TRE_OAUTH.replace(':code', code).replace(':user_id', user_id.toString()));
}
